import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatChipInputEvent } from '@angular/material/chips';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.less'],
  standalone: false
})

export class FilterComponent implements OnChanges {
    @Input() separatorKeysCodes: number[] = [];
    @Input() addOnBlur: boolean = true;
    @Input() disabled: boolean = false;
    @Input() selectable: boolean = true;
    @Input() removable: boolean = true;
    @Input() isShowAllEnabled: boolean = false;

    @Input() searchItems: any[] = [];
    @Output() searchItemsChange = new EventEmitter<any[]>(); // Para two-way binding si lo necesitas

    @Output() filterChange = new EventEmitter<string>();

    ngOnChanges(changes: any) {
        if (changes.isShowAllEnabled)
            this.updateFilter();
    }
    applyFilter(event: MatChipInputEvent): void {
        const input = event.input;
        const value = event.value;
        if ((value || '').trim()) {
            this.searchItems.push({ name: value.replace('+', '').trim() });
            this.searchItemsChange.emit(this.searchItems);
            this.updateFilter();
        }
        if (input) {
            input.value = '';
        }
    }

    remove(item: any): void {
        const index = this.searchItems.indexOf(item);
        if (index >= 0) {
            this.searchItems.splice(index, 1);
            this.searchItemsChange.emit(this.searchItems);
            this.updateFilter();
        }
    }

    updateFilter() {
        let filterString: string;
        if (this.searchItems.length === 0) {
            filterString = `+${this.isShowAllEnabled ? 'ShowAllKpiItems' : 'HideEmptyKpiItems'}`;
        } else {
            filterString = this.searchItems.map(e => e.name).join('+')
                .concat(`+${this.isShowAllEnabled ? 'ShowAllKpiItems' : 'HideEmptyKpiItems'}`);
        }

        this.filterChange.emit(filterString);
    }
}